import { message } from 'antd';
import type { TFunction } from 'i18next';
import { ApiError } from '../../lib/api-client';

/** Fetches a CSV export and hands it to the browser as a file; a failure shows the server's message. */
export async function downloadCsv(
  t: TFunction,
  fetchCsv: () => Promise<string>,
  filename: string,
  failureKey: string,
): Promise<void> {
  try {
    const csv = await fetchCsv();
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  } catch (e) {
    void message.error(e instanceof ApiError ? e.message : t(failureKey));
  }
}
